import React from 'react';

import { PROFILE_ROLE } from '../../types';

import SidebarFooter from './sidebar-footer/sidebar-footer';
import SidebarHeader from './sidebar-header/sidebar-header';
import SidebarMenu from './sidebar-menu/sidebar-menu';

import './sidebar.scss';

interface SidebarProps {
  sm?: boolean;
  accountName?: string;
  accountRole?: PROFILE_ROLE;
  companyName?: string;
  companyPhoto?: string;
  pathname: string;
}

const Sidebar: React.FC<SidebarProps> = ({
  sm,
  accountName,
  companyName,
  accountRole,
  pathname,
  companyPhoto,
}) => (
  <aside className="sidebar">
    <SidebarHeader sm={sm} />
    <div className="sidebar__body">
      <SidebarMenu pathname={pathname} sm={sm} />
    </div>
    <div className="sidebar__footer">
      <SidebarFooter
        accountName={accountName}
        accountRole={accountRole}
        companyName={companyName}
        companyPhoto={companyPhoto}
        sm={sm}
      />
    </div>
  </aside>
);

export default Sidebar;
